export default "__VITE_PUBLIC_ASSET__cca63d51__"